namespace Matrix.Rebalancer {
    export interface InstructionTaskMapForm {
        InstructionFilterScript: CodeEditor;
        TaskTypeCode: Serenity.StringEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class InstructionTaskMapForm extends Serenity.PrefixedContext {
        static formKey = 'Rebalancer.InstructionTaskMap';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!InstructionTaskMapForm.init)  {
                InstructionTaskMapForm.init = true;

                var s = Serenity;
                var w0 = CodeEditor;
                var w1 = s.StringEditor;
                var w2 = StaticTextBlock;
                var w3 = ReadOnlyDateTime;

                Q.initFormType(InstructionTaskMapForm, [
                    'InstructionFilterScript', w0,
                    'TaskTypeCode', w1,
                    'CreatedBy', w2,
                    'CreatedWhen', w3,
                    'UpdatedBy', w2,
                    'UpdatedWhen', w3,
                    'Version', w2
                ]);
            }
        }
    }
}
